import './ImgSpot.css';

function ImgSpot({ img }) {
  return (
    <>
      <div
        style={{ backgroundImage: `url( ${img} )` }}
        className="imgSpotDiv"
      ></div>
    </>
  );
}

export default ImgSpot;
